<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M14.5 23.9998C14.167 23.9998 13.854 23.8338 13.668 23.5548L11.965 20.9998H10C9.448 20.9998 9 20.5518 9 19.9998C9 
    19.4478 9.448 18.9998 10 18.9998H12.5C12.834 18.9998 13.146 19.1668 13.332 19.4448L14.376 21.0108L16.605 16.5518C16.769 
    16.2258 17.096 16.0138 17.461 15.9998C17.849 15.9908 18.169 16.1718 18.357 16.4838L21.066 20.9998H23C23.552 20.9998 
    24 21.4478 24 21.9998C24 22.5518 23.552 22.9998 23 22.9998H20.5C20.149 22.9998 19.823 22.8158 19.643 22.5148L17.58 
    19.0768L15.395 23.4478C15.235 23.7668 14.918 23.9768 14.562 23.9988C14.542 23.9998 14.521 23.9998 14.5 23.9998Z"
    fill="white"
    fill-opacity="0.75"
  />
  <path
    d="M9 10C11.7614 10 14 7.76142 14 5C14 2.23858 11.7614 0 9 0C6.23858 0 4 2.23858 4 5C4 7.76142 6.23858 10 9 10Z"
    fill="white"
    fill-opacity="0.75"
  />
  <path
    d="M7 20C7 18.346 8.346 17 10 17H12.5C13.019 17 13.519 17.133 13.958 17.377L14.817 15.658C15.254 14.787 16.086 
    14.216 17.031 14.064C16.121 12.819 14.661 12 13 12H5C2.239 12 0 14.239 0 17V20.25C0 20.664 0.336 21 0.75 
    21H7.184C7.072 20.686 7 20.352 7 20Z"
    fill="white"
    fill-opacity="0.75"
  />
</svg>
